import { computed, Directive, effect, inject, input, TemplateRef, ViewContainerRef } from "@angular/core";
import { UserRole } from "../../shared/data-types/roles.enum";
import { User } from "../../shared/models/user";
import { AuthStore } from "../../shared/store/auth.store";

@Directive({
  selector: "[hasRole]",
})
export class HasRoleDirective {
  private templateRef = inject(TemplateRef);
  private viewContainerRef = inject(ViewContainerRef);
  private authStore = inject(AuthStore);

  roles = input.required<UserRole[]>({
    alias: "hasRole",
  });

  constructor() {
    effect(() => {
      const canShow = computed(() => {
        const user = this.authStore.currentUser(); 
        const roles = this.roles();
  
        return !!user && roles.length > 0 && this.hasRole(user, roles);
      });
  
      this.viewContainerRef.clear();
  
      if (canShow()) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
    });
  }

  hasRole(user: User | null, roles: UserRole[]): boolean {
    return !!user && roles.includes(user.role);
  }
}
